import React, {FunctionComponent, useState} from "react"
import {PersonalBest} from "/src/domain/challenges/ChallengeUserRatingData";
import {theme} from "/src/assets/theme";
import Carousel from "react-material-ui-carousel";
import makeStyles from "@mui/styles/makeStyles";
import {PersonalBestView} from "/src/ui/challengeUserRating/PersonalBestView";

export type PersonalBestCarouselProps = {
    pbs: PersonalBest[]
}

export const PersonalBestCarousel: FunctionComponent<PersonalBestCarouselProps> = ({pbs}) => {
    const [activeProtocolIndex, setActiveProtocolIndex] = useState(0);
    const classes = useStyles();

    return (
        <Carousel
            animation="slide"
            timeout={500}
            interval={5000}
            autoPlay={true}
            indicators={pbs.length !== 1}
            navButtonsAlwaysInvisible={pbs.length === 1}
            className={classes.carousel}
            onChange={setActiveProtocolIndex}
            indicatorContainerProps={{
                style: {
                    margin: 0,
                    paddingTop: '0.5rem',
                }
            }}
            indicatorIconButtonProps={{
                style: {
                    backgroundColor: theme.secondaryColor,
                    color: theme.WHITE_COLOR,
                    margin: '0 0.2rem',
                    transform: 'scale(0.5)'
                }
            }}
            activeIndicatorIconButtonProps={{
                style: {
                    color: theme.secondaryColor
                }
            }}
        >
            {
                pbs.map(pb => (
                    <PersonalBestView
                        key={pb.id}
                        pb={pb}
                    />))
            }
        </Carousel>
    )
}

const useStyles = makeStyles(theme => ({
        carousel: {
            margin: '0 auto',
            maxWidth: '35rem',
            padding: "0 1.5rem"
        }
    }
));